import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { CountryService } from "../country/service/country.service";
import { StateService } from "../state/service/state.service";
import { CityService } from "../city/service/city.service";
import { CategoryService } from "src/app/services/category.service";
import { AcademyService } from "../academies/service/academies.service";
import { AcademyCourtService } from "src/app/services/academyCourt.service";
import { ReportService } from "src/app/services/report.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Table } from "primeng/table";

@Component({
  selector: 'app-court-bookings-revenue',
  templateUrl: './court-bookings-revenue.component.html',
  styleUrls: ['./court-bookings-revenue.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe],
})

export class CourtBookingsRevenueComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  errorMessage = "";
  searchBy: any[];
  totalRecords: 0;
  courtBookingsRevenueData: any;
  loading: boolean;
  paginationOption;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  @ViewChild("dt", { static: false }) public dt: Table;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  searchby;
  public hide: boolean = true;
  sportList: any;
  countrylist: any[];
  stateList: any[];
  cityList: any[];
  countryCode: string;
  academiesList: any;
  venueList: any[] = [];
  academyTournamentsList: any;
  country: any;
  state: any;
  cityName: any;
  sportName: any;
  academyId: any;
  venueId: any;
  downloadCourtBookingsRevenueDataList: any;

  constructor(
    private countryService: CountryService,
    private stateService: StateService,
    private cityService: CityService,
    private categoryService: CategoryService,
    private academyService: AcademyService,
    private academyCourtService: AcademyCourtService,
    private reportService: ReportService
  ) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Created On', value: "created_at" }
    ];
    this.downloadFlg = false;
    this.getCountries();
    this.getSportList();
    this.getAcademies();
    this.getVenues();
  }

  getAcademies() {
    let query = "?filterByDisable=false&filterByStatus=true";
    this.academyService.getAcademyList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.academiesList = data.data.items;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getSportList() {
    const query = `?filterByDisable=false&getSubcategory=true&pageSize=10&pageNumber=1&filterByParentCategory=Sport`;
    this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.sportList = data?.data?.items;
    }, err => {
      this.errorMessage = err.error.message;
    })
  }

  getVenues() {
    let query = "?filterByDisable=false&filterByStatus=true";
    if (this.academyId) {
      query += "&filterByAcademyId=" + this.academyId;
    }
    if (this.sportName) {
      query += "&filterBySportType=" + this.sportName;
    }
    this.academyCourtService.getAcademyCourtList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        this.venueList = data?.data?.items || [];
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getCountries() {
    this.countrylist = [];
    this.stateList = [];
    this.cityList = [];
    let query = "filterByDisable=false&filterByStatus=true";
    this.countryService.getcountryList(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        if (data.data.items.length > 0) {
          data.data.items.forEach(element => {
            let countryObj = {
              name: element.name,
              iso2: element.iso2,
            }
            this.countrylist.push(countryObj);
          });
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getStates(event) {
    this.stateList = [];
    this.cityList = [];
    this.state = null;
    this.cityName = null;
    if (event.value !== null) {
      let countryCode = event.value.iso2;
      let query = "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" + countryCode;
      this.stateService.getstateList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
  
        if (res.data.items.length > 0) {
          res.data.items.forEach(element => {
            let stateObj = {
              name: element.name,
              id: element.id,
            }
            this.stateList.push(stateObj);
          });
        }
      })
    }
    this.loadCourtBookingsRevenue(this.lastTableLazyLoadEvent);
  }

  async getCities(event) {
    this.cityList = [];
    this.cityName = null;
    if (event.value !== null) {
      const stateCode = event.value.id;
      let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateCode;
      this.cityService.getcityList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
        if (res.data.items.length > 0) {
          res.data.items.forEach(element => {
            let cityObj = {
              name: element.name,
              code: element.name,
            }
            this.cityList.push(cityObj);
          });
        }
      })
    }
    this.loadCourtBookingsRevenue(this.lastTableLazyLoadEvent);
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.stateList = [];
    this.cityList = [];
    this.country = null;
    this.state = null;
    this.cityName = null;
    this.sportName = null;
    this.academyId = null;
    this.venueId = null;
    this.getVenues();
    const resetEvent = Object.assign({}, this.lastTableLazyLoadEvent, { first: 0, filters: {} });
    if (this.dt) {
      this.dt.filters = {};
      this.dt.first = 0;
    }
    this.loadCourtBookingsRevenue(resetEvent);
  }

  onAcademyChange(event) {
    this.academyId = event.value;
    this.venueId = null;
    this.getVenues();
    const resetEvent = Object.assign({}, this.lastTableLazyLoadEvent, { first: 0 });
    this.loadCourtBookingsRevenue(resetEvent);
  }

  onSportChange(event) {
    this.sportName = event.value;
    this.venueId = null;
    this.getVenues();
    const resetEvent = Object.assign({}, this.lastTableLazyLoadEvent, { first: 0 });
    this.loadCourtBookingsRevenue(resetEvent);
  }

  onVenueChange(event) {
    this.venueId = event.value;
    const resetEvent = Object.assign({}, this.lastTableLazyLoadEvent, { first: 0 });
    this.loadCourtBookingsRevenue(resetEvent);
  }

  loadCourtBookingsRevenue(event: LazyLoadEvent) {
    event = event || {} as LazyLoadEvent;
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (this.country) {
      params += "&filterByCountry=" + this.country.name;
    }

    if (this.state) {
      params += "&filterByState=" + this.state.name;
    }

    if (this.cityName) {
      params += "&filterByCity=" + this.cityName;
    }

    if (this.sportName) {
      params += "&filterBySportwise=" + this.sportName;
    }

    if (this.academyId) {
      params += "&filterByAcademy=" + this.academyId;
    }

    if (this.venueId) {
      params += "&filterByVenue=" + this.venueId;
    }

    const getFilterValue = (field) => {
      if (event.filters != undefined && event.filters[field] != undefined && event.filters[field].value !== undefined && event.filters[field].value !== null && event.filters[field].value !== "") {
        return event.filters[field].value;
      }
      return null;
    };
    const columnFilters = [
      { field: "mobileNumber", parameter: "filterByCourtMobileNumber" },
      { field: "username", parameter: "filterByCourtUsername" },
      { field: "bookingId", parameter: "filterByCourtBookingId" },
      { field: "bookingDate", parameter: "filterByCourtBookingDate" },
      { field: "propertyName", parameter: "filterByCourtPropertyName" },
      { field: "venueId", parameter: "filterByCourtVenueId" },
      { field: "venueName", parameter: "filterByCourtVenueName" },
      { field: "venueCity", parameter: "filterByCourtVenueCity" },
      { field: "venueState", parameter: "filterByCourtVenueState" },
      { field: "venueCountry", parameter: "filterByCourtVenueCountry" },
      { field: "bookingStartTime", parameter: "filterByCourtBookingStartTime" },
      { field: "bookingEndTime", parameter: "filterByCourtBookingEndTime" },
      { field: "bookingHours", parameter: "filterByCourtBookingHours" },
      { field: "bookingAmount", parameter: "filterByCourtBookingAmount" },
      { field: "couponApplied", parameter: "filterByCourtCouponApplied" },
      { field: "couponDiscountAmountVenue", parameter: "filterByCourtCouponDiscountVenue" },
      { field: "couponDiscountAmountTPL", parameter: "filterByCourtCouponDiscountTPL" },
      { field: "rescheduleBookingId", parameter: "filterByCourtRescheduleBookingId" },
      { field: "onlineAddOnProducts", parameter: "filterByCourtOnlineAddOnProducts" },
      { field: "onlineAddOnAmount", parameter: "filterByCourtOnlineAddOnAmount" },
      { field: "tplCommissionPercent", parameter: "filterByCourtCommissionPercent" },
      { field: "tplCommission", parameter: "filterByCourtCommission" },
      { field: "onlineAddOnTPLCommissionPercent", parameter: "filterByCourtAddOnCommissionPercent" },
      { field: "onlineAddOnTPLCommission", parameter: "filterByCourtAddOnCommission" },
      { field: "tplRevenue", parameter: "filterByCourtTplRevenue" },
      { field: "gstAmount", parameter: "filterByCourtGstAmount" },
      { field: "venuePayout", parameter: "filterByCourtVenuePayout" },
      { field: "tplShare", parameter: "filterByCourtTplShare" },
    ];

    columnFilters.forEach(columnFilter => {
      const value = getFilterValue(columnFilter.field);
      if (value !== null) {
        params += "&" + columnFilter.parameter + "=" + encodeURIComponent(String(value));
      }
    });

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "ASC";
      } else {
        orderBy = "DESC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.reportService.getCourtBookingsRevenue(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        if (this.downloadFlg === false) {
          this.loading = false;
          this.courtBookingsRevenueData = data;
          this.totalRecords = data.totalCount;
        } else {
          this.exportCourtBookingsRevenueReportListData(data);
          this.downloadFlg = false;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadCourtBookingsRevenue(this.lastTableLazyLoadEvent);
  }

  async exportCourtBookingsRevenueReportListData(userReportList) {
    this.downloadCourtBookingsRevenueDataList = JSON.parse(JSON.stringify(userReportList));
    var propertiesRemove = ['message', 'pageNumber', 'pageSize', 'status', 'totalCount', 'totalPages'];
    propertiesRemove.forEach((prop) => {
      delete this.downloadCourtBookingsRevenueDataList[prop];
    });

    const summaryHeaders = [
      'Total Number Of Users', 'Total Bookings Made', 'Total Booking Amount', 'Total Coupon Amount (Venue)',
      'Total Coupon Amount (TPL)', 'Total TPL Commission', 'Total TPL Add On Commission',
      'Total TPL Revenue', 'Total Venue Payout', 'Total TPL Share'
    ];
    const columnHeaders = [
      'Mobile Number', 'Username', 'Booking ID', 'Booking Date', 'Property Name', 'Venue ID', 'Venue Name',
      'Venue City', 'Venue State', 'Venue Country', 'Booking Start Time', 'Booking End Time', 'Booking Hours',
      'Booking Amount', 'Coupon Applied', 'Coupon Discount Amount (Venue)', 'Coupon Discount Amount (TPL)',
      'Reschedule Booking ID', 'Online Add On Products', 'Online Add On Amount', 'TPL Commission %',
      'TPL Commission', 'Online Add On TPL Commission %', 'Online Add On TPL Commission', 'TPL Revenue',
      'GST Amount', 'Venue Payout', 'TPL Share'
    ];
    const { Workbook } = await import('exceljs');
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Court_Bookings_Revenue');

    worksheet.addRow([]);
    const summaryHeaderRow = worksheet.addRow(summaryHeaders);
    summaryHeaderRow.eachCell(cell => {
      cell.font = { bold: true };
    });
    worksheet.addRow([
      this.downloadCourtBookingsRevenueDataList.summary.totalNumberOfUsers,
      this.downloadCourtBookingsRevenueDataList.summary.totalBookingsMade,
      this.downloadCourtBookingsRevenueDataList.summary.totalBookingAmount,
      this.downloadCourtBookingsRevenueDataList.summary.totalCouponAmountVenue,
      this.downloadCourtBookingsRevenueDataList.summary.totalCouponAmountTPL,
      this.downloadCourtBookingsRevenueDataList.summary.totalTPLCommission,
      this.downloadCourtBookingsRevenueDataList.summary.totalTPLAddOnCommission,
      this.downloadCourtBookingsRevenueDataList.summary.totalTPLRevenue,
      this.downloadCourtBookingsRevenueDataList.summary.totalVenuePayout,
      this.downloadCourtBookingsRevenueDataList.summary.totalTPLShare,
    ]);
    worksheet.addRow([]);
    const columnHeaderRow = worksheet.addRow(columnHeaders);
    columnHeaderRow.eachCell(cell => {
      cell.font = { bold: true };
    });

    columnHeaders.forEach((header, index) => {
      worksheet.getColumn(index + 1).width = Math.min(Math.max(header.length + 2, 15), 35);
    });

    this.downloadCourtBookingsRevenueDataList['data'].forEach((parent: any) => {
      if (parent.bookingDate) {
        parent.bookingDate = moment(parent.bookingDate).format("DD-MM-YYYY");
      }
      worksheet.addRow([
        parent.mobileNumber,
        parent.username,
        parent.bookingId,
        parent.bookingDate,
        parent.propertyName,
        parent.venueId,
        parent.venueName,
        parent.venueCity,
        parent.venueState,
        parent.venueCountry,
        parent.bookingStartTime,
        parent.bookingEndTime,
        parent.bookingHours,
        parent.bookingAmount,
        parent.couponApplied || '-',
        parent.couponDiscountAmountVenue > 0 ? parent.couponDiscountAmountVenue : '-',
        parent.couponDiscountAmountTPL > 0 ? parent.couponDiscountAmountTPL : '-',
        parent.rescheduleBookingId || '-',
        parent.onlineAddOnProducts,
        parent.onlineAddOnAmount,
        parent.tplCommissionPercent,
        parent.tplCommission,
        parent.onlineAddOnTPLCommissionPercent,
        parent.onlineAddOnTPLCommission,
        parent.tplRevenue,
        parent.gstAmount,
        parent.venuePayout,
        parent.tplShare,
      ]);
    });

    const excelBuffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([excelBuffer]), "Court_Bookings_Revenue.xlsx");

    this.downloadFlg = false;
  }

  /**
   * Use to add more columns in the table.
   */
  addColumns() {
    this.hide = false;
  }

  /**
   * Use to remove more columns in the table.
   */
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
